'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _datetime = require('helpers/datetime');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var yesterday = (0, _moment2.default)().subtract(1, 'day');

var datePickerProps = {
  dateFormat: _datetime.dateFormat.date,
  timeFormat: false,
  closeOnSelect: true,
  inputProps: { className: 'dateTimeInput' },
  isValidDate: function isValidDate(current) {
    return current.isAfter(yesterday);
  }
};

exports.default = datePickerProps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/datePickerProps.js
// module id = 861
// module chunks = 1